import { IFileReaderResult } from './file-reader-result';
import { IAgeRatings } from '../constants/age-ratings';
import { EDITION } from '../constants/editions';

export enum ITEM_TYPE {
    SECONDARY_STORE_ITEM = 'Secondary Store Item',
    SECONDARY_STORE_OFFER = 'Secondary Store Offer',
    KEY_DISTRIBUTION = 'Key distribution',
    KEY_DELIVERY = 'Key delivery',
    CLUB_REWARD = 'Club Reward',
    CLUB_ACTION = 'Club Action',
    POPULATION = 'Population',
    BETA = 'Beta Access'
}

export type ContentPackOwnershipGroup = string[];

export interface IContentPackItemBase {
    readonly packId: string;
    readonly name?: string;
    readonly projectId?: number;
    readonly type?: ITEM_TYPE;
    readonly hidden?: boolean;

    /* Key delivery item props */
    readonly description?: string;
    readonly edition?: EDITION;
    readonly ratings?: IAgeRatings;
    readonly ownershipGroups?: ContentPackOwnershipGroup[];
    /* Workaround for matching pack item with redeem api games list */
    readonly actionIds?: string[];
}

export interface IContentPackItem extends IContentPackItemBase {
    readonly imageSrc?: IFileReaderResult | string | null;
    readonly deleted?: boolean;
    readonly alreadyOwned?: boolean;
}
